// API configuration
//
// NOTE: In CRA/Craco builds, `process.env.REACT_APP_*` variables are baked into the JS bundle
// at BUILD TIME. If production is calling localhost, it means the deployed bundle was built
// with a localhost value (or a stale service-worker-cached bundle is still being served).

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');

if (!BACKEND_URL) {
  // Fail fast so misconfigured environments are obvious.
  throw new Error(
    'Missing REACT_APP_BACKEND_URL. Set it to something like https://api.theudt.in (prod) or http://localhost:<backend-port> (local).',
  );
}

const API = `${BACKEND_URL}/api`;

export { BACKEND_URL, API };

